import { render, staticRenderFns } from "./BillingMethodsList.vue?vue&type=template&id=72d7b1c8&scoped=true&"
import script from "./BillingMethodsList.vue?vue&type=script&lang=js&"
export * from "./BillingMethodsList.vue?vue&type=script&lang=js&"
import style0 from "./BillingMethodsList.vue?vue&type=style&index=0&id=72d7b1c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d7b1c8",
  null
  
)

export default component.exports